import { useState } from "react";
import type { Programa } from "@/interfaces/programa.interface";
import type { ActividadPrograma } from "@/interfaces/actividadPrograma.interface";

interface ProgramaReportesProps {
  idPrograma: number;
  programa: Programa;
}

export function ProgramaReportes({
  idPrograma: _idPrograma,
  programa: _programa,
}: ProgramaReportesProps) {
  const [, setModalReporteProgramaOpen] = useState(false);
  const [, setActividadReporteModalOpen] = useState(false);
  const [, setActividadForReporte] = useState<ActividadPrograma | null>(null);

  // Suppress unused-setter warnings — state is kept for when modals are re-enabled
  void setModalReporteProgramaOpen;
  void setActividadReporteModalOpen;
  void setActividadForReporte;

  return null;

  /* Temporalmente deshabilitados para corregir errores */
  /*
  return (
    <>
      <ModalReportePrograma
        programa={programa}
        open={modalReporteProgramaOpen}
        onOpenChange={setModalReporteProgramaOpen}
      />
      {actividadForReporte && (
        <ModalReporteActividad
          actividad={actividadForReporte}
          open={actividadReporteModalOpen}
          onOpenChange={setActividadReporteModalOpen}
        />
      )}
    </>
  );
  */
}

// Export state setter types for orchestrator usage
export type ProgramaReportesHandles = {
  openReportePrograma: () => void;
  openReporteActividad: (actividad: ActividadPrograma) => void;
};

/**
 * Hook-like helper to manage reporte state at the orchestrator level.
 * Since the report modals are currently commented out, this keeps the
 * state management in place for when they are re-enabled.
 */
export function useReportesState() {
  const [, setModalReporteProgramaOpen] = useState(false);
  const [, setActividadReporteModalOpen] = useState(false);
  const [, setActividadForReporte] = useState<ActividadPrograma | null>(null);

  return {
    openReportePrograma: () => setModalReporteProgramaOpen(true),
    openReporteActividad: (actividad: ActividadPrograma) => {
      setActividadForReporte(actividad);
      setActividadReporteModalOpen(true);
    },
  };
}
